export const prerender = "auto";

export const load = async ({ url }) => {
	return {
		url
	};
};
